import "./cision-form.scss";

(function () {
    if (document.querySelectorAll(".js-cision-reports").length > 0) {

        const cisionFormReports = {
            store: {
                errorCount: 0
            },
            init: function () {
                this.checkQueryString();
                this.validateForm();
            },
            checkQueryString: () => {
                const successMessageBox = document.getElementById("result__success");
                const urlParams = new URLSearchParams(window.location.search);
                const success = urlParams.get("successfulSubmit");
                const error = urlParams.get("ERROR");

                if (success !== null) {
                    if (success == "true") {
                        successMessageBox.classList.add("success");
                    } else {
                        if (error == "RECAPTCHA_INVALID") {
                            successMessageBox.classList.add("fail");
                        } else {
                            successMessageBox.classList.add("fail");
                        }
                    }
                }
            },
            validateForm: () => {
                const submitFormButton = document.getElementById("cision-reports-submit");

                submitFormButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    cisionFormReports.store.errorCount = 0;
                    cisionFormReports.validateDownloads();
                    cisionFormReports.validateInputs();
                    cisionFormReports.submitForm();
                });
            },
            validateDownloads: () => {
                const form = document.getElementById("cision__reports");
                const itemsList = document.getElementById("cision__reports--items");

                const downloadCheckboxes = form.querySelectorAll(
                    "input[type='checkbox']:checked"
                );

                if (downloadCheckboxes.length === 0) {
                    itemsList.classList.add("form__error");
                    cisionFormReports.store.errorCount++;
                } else {
                    itemsList.classList.remove("form__error");
                }
            },
            validateInputs: () => {
                const form = document.getElementById("cision__reports");
                const textInputs = form.querySelectorAll("input[type='text']");

                textInputs.forEach((input) => {
                    if (input.id !== "cision-state" && input.id !== "cision-company") {
                        if (input.value.length === 0) {
                            input.parentElement.classList.add("form__error");
                            cisionFormReports.store.errorCount++;
                        } else {
                            input.parentElement.classList.remove("form__error");
                        }
                    }
                });
            },
            submitForm: () => {
                if (cisionFormReports.store.errorCount === 0) {
                    const formElement = document.getElementById("cision__reports");

                    formElement.submit();
                }
            },
        };

        cisionFormReports.init();
    }
})();
